import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "notif-close" }, null, -1)
const _hoisted_2 = { class: "notif-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "notif-wrap" }
const _hoisted_5 = { class: "notif-wrap__title" }
const _hoisted_6 = {
  key: 0,
  class: "notif__name"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "notif-wrap__text" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "notif__media"
}

import { onMounted } from "vue";
import { AppNotification } from "@/types/notification/AppNotification";
import { useUserInfo } from "@/composition/user/useUserInfo";
import { useNotificationInfo } from "@/composition/notifications/useNotificationInfo";
import { AppNotificationsTypeEnum } from "@/utils/enum/notifications/appNotificationsTypeEnum";
import { useContentInfo } from "@/composition/content/useContentInfo";
import { useNumberFormatter } from "@/composition/common/useNumberFormatter";
import { useUtilStore } from "@/stores/util";
import { CurrencyEnum } from "@/utils/enum/wallet/currencyEnum";
import AppNotificationContentType from "@/components/common/content/AppNotificationContentType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNotificationCard',
  props: {
    notification: null,
    t: null
  },
  setup(__props: any) {

const props = __props as {
  notification: AppNotification;
  t: unknown;
}



const { setUser, userFullName } = useUserInfo();
const utilStore = useUtilStore();
const {
  setNotification,
  notificationType,
  isAttentionNotification,
  isNotificationContainsMedia,
  notificationAmount,
  notificationCurrency,
  appointNotificationIcon,
} = useNotificationInfo();
const { setContent, contentType, contentFileUrl, contentPreviewUrl } =
  useContentInfo();

const { formatNumberByDefault } = useNumberFormatter();

onMounted(() => {
  setNotification(props.notification);
  setUser(props.notification?.subUser || null);
  setContent(props.notification?.content || null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_unref(notificationType))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(appointNotificationIcon),
            alt: "notification"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isAttentionNotification))
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).SELL_NFT_SUCCESSFUL
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-20")) + " " + _toDisplayString(_unref(userFullName)) + " (" + _toDisplayString(_unref(formatNumberByDefault)(_unref(notificationAmount))) + ") " + _toDisplayString(_unref(CurrencyEnum).MATIC) + " - $" + _toDisplayString(_unref(formatNumberByDefault)(
              _unref(utilStore).calcCurrencyUsdPrice(
                _unref(notificationAmount),
                _unref(CurrencyEnum).MATIC
              )
            )), 1)
                  ], 64))
                : (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).TRANSFER_NFT_SUCCESSFUL
          )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(__props.t("notification-phrase-15")) + " " + _toDisplayString(_unref(notificationAmount)) + " " + _toDisplayString(__props.t("notification-phrase-21")) + " " + _toDisplayString(_unref(userFullName) || __props.t("notification-phrase-22")), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(userFullName)), 1)
                    ], 64))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_7, [
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).DEPOSIT_SUCCESSFUL
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-4")) + " " + _toDisplayString(_unref(formatNumberByDefault)(_unref(notificationAmount))) + " " + _toDisplayString(_unref(notificationCurrency)) + " " + _toDisplayString(__props.t("notification-phrase-19")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).NFT_AUCTION_TIME_OUT
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-23")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).WITHDRAWAL_REQUEST_SUCCESS
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-5")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).WITHDRAWAL_CONFIRMATION
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-6")) + " " + _toDisplayString(_unref(formatNumberByDefault)(_unref(notificationAmount))) + " " + _toDisplayString(_unref(notificationCurrency)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).CHANGE_PASSWORD_SUCCESSFUL
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-8")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).REPORT_ON_YOUR_POST
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-9")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).POST_GET_10_YRM_MINTING_NFT_AVAILABLE
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-10")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).CALIBRATED_THE_FEED_SUCCESSFUL
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-11")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).YOUR_AUCTION_CLOSED
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-13")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).NFT_MINTED_SUCCESSFUL
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-16")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).YOUR_BID_WIN_ON_AUCTION
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-17")), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!_unref(isAttentionNotification))
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).NEW_LIKE_ON_YOUR_POST
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-2")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) === _unref(AppNotificationsTypeEnum).NEW_YRM_ON_YOUR_POST
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-3")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(notificationType) === _unref(AppNotificationsTypeEnum).NEW_SUBSCRIBER)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-7")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _unref(notificationType) ===
            _unref(AppNotificationsTypeEnum).NEW_BID_ON_YOUR_AUCTION
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(__props.t("notification-phrase-12")), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(isNotificationContainsMedia))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(AppNotificationContentType, {
                "file-url": _unref(contentFileUrl),
                "preview-url": _unref(contentPreviewUrl),
                "content-type": _unref(contentType)
              }, null, 8, ["file-url", "preview-url", "content-type"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})